import axios from 'axios';

export const register = async (info) => {

    const { data } = await axios.post(`${process.env.REACT_APP_AWS_URL}/signup`, info);

    return data;

}

export const emailCheck = async (email) => {
    const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/userids/duplicate/?userID=${email}`);

    return data;
}

export const confirmEmail = async (email) => {
    const { data } = await axios.put(`${process.env.REACT_APP_AWS_URL}/api/users/confirmemail`, { email });
    return data;
}

export const loginCheck = () => {

    if (window.localStorage.getItem(`${process.env.REACT_APP_TOKEN_KEY}`)) {
        return true;
    }

    return false;

}

export const login = (userID, userPassword, fcm_token) => {

    return axios.post(`${process.env.REACT_APP_AWS_URL}/login`, {
        userID,
        userPassword,
        fcm_token
    });


}

// export const logout = () => {
//     window.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_KEY}`);
// }

export const personalinfo = async () => {

    const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/personalinfo`, {
        headers: {
            authorization: `Bearer ${localStorage.getItem(`${process.env.REACT_APP_TOKEN_KEY}`)}`
        }
    });

    // console.log(data.data)

    return data.data;
}





